@import 'src/styles/common/_colors.scss';

.connectivityPopoverPopover {
    background-color: $mightnight-black;
    color: $white;
    min-width: 370px !important;
    max-width: 370px !important;
    border: 1px solid $smoke-white;
    position: fixed !important;
    .popoverHeader {
        background-color: $mightnight-black;
        white-space: normal;
        color: $white;
        font-size: 12px !important;
        padding: 20px 20px 0px 20px;
        white-space: normal;

        .closeIcon {
            position: absolute;
            right: 0px;
            font-size: 9px !important;
            color: $white;
            cursor: pointer;
            top: 10px;
        }

        .headerTitle {
            border-bottom: 1px solid $lightgray;
            padding-bottom: 5px;
        }
    }

    .popoverArrow::after {
        border-bottom-color: $mightnight-black !important;
        border-top-color: $mightnight-black !important;
    }

    .popoverHeader::before {
        border-bottom: none !important;
    }

    .popoverArrow {
        left: 15px !important;
    }

    .popoverBody {
        padding: 0.325rem 1.25rem;
        max-height: 300px;
        overflow: auto;
    }

    .connectionBody {
        padding: 5px 0;
        color: $white;
        font-size: 11px;

        div {
            padding-bottom: 5px;
        }

    }

    .borderBottom {
        border-bottom: 1px solid #dee2e6 !important;
    }

    .deviceDisconnected {
        color: $light-red;
        font-weight: 700;
    }

    .deviceConnected {
        color: $tile;
        background-color: transparent;
        font-weight: 700;
    }

    .deviceNotSupported {
        color: $white;
        background-color: transparent;
        font-weight: 700;
    }
}